// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../../css-global/colors.scss\"","GrayPale":"#f0f6fa","root":"Banner-module--root--2TLyB","bannerImage":"Banner-module--bannerImage--L9m3B"};